import { cloneDeep } from 'lodash/fp';
import mixpanelSingleton from '@/mixpanel/mixpanelSingleton.js';
import account from './account.js';
import projects from './projects.js';
import status from './status.js';
import currentMembership from './currentMembership.js';
import externalMemberships from './externalMemberships.js';
import memberships from './memberships.js';

const state = {};

const getters = {};

const actions = {
  /**
   * Set the state account to the given value if not null, else reset the state
   */
  setAccount(context, { value }) {
    context.commit('account/setAccount', {
      value: value || {
        id: null,
        email: null,
        firstName: null,
        lastName: null,
        shortName: null,
        color: null,
        gravatarUrl: null,
        avatarUrl: null,
        plan: null,
        isSubscribed: null,
        paymentMethod: null,
      },
    });
    // mix panel update user profile or create user profile
    if (value !== null && value !== undefined) {
      mixpanelSingleton.identify(value.id);
    }
  },

  /**
   * Set the state projects to the given value if not null, else reset the state
   */
  setProjects(context, { value }) {
    context.commit(
      'projects/setProjects',
      cloneDeep(value) || { list: {}, open: null, participants: {} }
    );
  },

  /**
   * Set the current membmership state to the given value if not null, else reset the state
   */
  setCurrentMembership(context, { value }) {
    context.commit('setCurrentMembership', {
      value: value || {
        id: null,
        role: null,
        permissions: [],
      },
    });
  },

  /**
   * Set the external memberships of the current user
   */
  setExternalMemberships(context, { value }) {
    context.commit(
      'user/externalMemberships/setExternalMemberships',
      { value },
      { root: true }
    );
  },

  setMemberships(context, { value }) {
    context.commit('memberships/setMemberships', { value });
  },
};

const mutations = {
  /**
   * Set the current membmership state to the given one
   * @param {Object} value  The projects
   */
  setCurrentMembership(state, { value }) {
    state.currentMembership = cloneDeep(value);
  },
};

const modules = {
  account,
  projects,
  status,
  currentMembership,
  externalMemberships,
  memberships,
};

const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
};

export default module;
